import React, {useEffect, useState} from 'react';

import {WordAdmin} from '#Client/components/AdminModal/WordAdmin';
import {WordFilter} from '#Client/components/AdminModal/WordFilter';
import {IMG_DIR} from '#Client/components/constants';
import {LoadingAnimation} from '#Client/components/LoadingAnimation/LoadingAnimation';
import {Modal} from '#Client/components/Modal/Modal';
import {Solution} from '#Client/components/SolutionsModal/Solution';
import {Tabs} from '#Client/components/Tabs/Tabs';
import {getTodaySolutions, SolutionsResponse} from '#Common/api/api';

type Props = {
  onClose: () => void;
};

export const AdminModal = ({onClose}: Props) => {
  const [selectedWord, setSelectedWord] = useState<string>('');
  const [solutions, setSolutions] = useState<SolutionsResponse>();
  const [isLoading, setIsLoading] = useState<boolean>(false);
  useEffect(() => {
    (async () => {
      setIsLoading(true);
      setSolutions(await getTodaySolutions());
      setIsLoading(false);
    })();
  }, []);
  return (
    <Modal
      image={`${IMG_DIR}icon_lightning_purple.png`}
      title="Admin"
      onClose={onClose}
    >
      <Tabs
        tabs={[
          {
            title: 'Solutions',
            content: isLoading ? (
              <LoadingAnimation />
            ) : solutions === undefined ? null : (
              (
                [
                  'puzzleEasy',
                  'puzzleMedium',
                  'puzzleHard',
                  'puzzleBrutal',
                ] as const
              ).map(difficulty => (
                <Solution
                  key={difficulty}
                  label={difficulty.replace('puzzle', '')}
                  puzzle={solutions[difficulty]}
                />
              ))
            ),
          },
          {
            title: 'Words',
            content: (
              <div>
                {selectedWord === '' ? (
                  <WordFilter setSelectedWord={setSelectedWord} />
                ) : (
                  <WordAdmin
                    word={selectedWord}
                    onClose={() => setSelectedWord('')}
                  />
                )}
              </div>
            ),
          },
        ]}
      />
    </Modal>
  );
};
